export default __webpack_public_path__ + "static/media/Liputon-logo-2019.5ede6ce4.svg";